export default {
  VEHICLE_CATEGORY_WRAPPER_CLASS: `cm_tile-{this.value.toLowerCase().replaceAll(' ', '-')}`,
};
